import { useNavigate } from 'react-router';

import { FigmaIcon } from '@app-velocity/icons';

import { Button } from '@app-velocity/ui';

import { AuthRoutesPaths } from '@app-velocity/libs/auth';

import { useAuthProviderContext } from '../../../../context/useAuthProviderContext';

export const FigmaSignInButton = () => {
  const navigate = useNavigate();
  const { type: authType, setProviderType } = useAuthProviderContext();

  const goToFigmaAuth = () => {
    if (authType === 'detached') {
      setProviderType('figma');

      return;
    }

    navigate(AuthRoutesPaths.FigmaAuth);
  };

  return (
    <Button
      fullWidth
      type="button"
      variant="contained"
      size="large"
      color="secondary"
      data-testid="form-login-figma"
      data-ph-capture-attribute-id="figma_auth_button"
      onClick={goToFigmaAuth}
    >
      <FigmaIcon /> Figma
    </Button>
  );
};
